import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { AnnulledPrescriptionPackage } from '~libs.shared.prescription';

import { annulledPrescriptionsTranslationKeys } from '../../../../translations';
import { PrescriptionListHeader } from '../prescription/PrescriptionListHeader/PrescriptionListHeader';

import { renderPrescriptionsList } from './SentPrescriptionPackagesList';
import { mapSentPrescriptionsToSentPrescriptionItems } from './SentPrescriptionPackagesList.utils';

type AnnulledPrescriptionsListProps = {
   readonly annulledPrescriptionPackages: AnnulledPrescriptionPackage[];
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const AnnulledPrescriptionsList = (props: AnnulledPrescriptionsListProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={'4px'}>
         <PrescriptionListHeader
            testId={'annulledPrescriptionsList'}
            label={annulledPrescriptionsTranslationKeys.prescriptionsAnnulled}
         />
         <StyledFlex direction={'column'} gap={'8px'}>
            {renderPrescriptionsList(
               props.annulledPrescriptionPackages
                  .map(({ prescriptions, recipientCategory }) =>
                     mapSentPrescriptionsToSentPrescriptionItems(prescriptions, recipientCategory)
                  )
                  .flat(1),
               props.visitDiagnoses
            )}
         </StyledFlex>
      </StyledFlex>
   );
};
